import PropTypes from 'prop-types';
import { Breadcrumbs } from '@bwoty-web/styleguide';

const BreadcrumbsView = ({ links }) => {
  return <Breadcrumbs links={links} />;
};

BreadcrumbsView.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      uri: PropTypes.string,
      target: PropTypes.string,
      desktopOnly: PropTypes.bool,
    }),
  ).isRequired,
};

export default BreadcrumbsView;
